<script setup lang="ts">
import zhCN from 'element-plus/es/locale/lang/zh-cn'

const settingsStore = useSettingsStore()

// 跟随框架主题
const isSupprotColorMix = false
// CSS.supports('color', 'color-mix(in srgb, #fff, #000)')
if (isSupprotColorMix) {
  document.body.style.setProperty('--el-bg-color', 'hsl(var(--background))')
  document.body.style.setProperty('--el-color-primary', 'hsl(var(--primary))')
  document.body.style.setProperty('--weyon-primary-color', 'hsl(var(--primary))')
  document.body.style.setProperty('--el-color-white', 'hsl(var(--primary-foreground))')
  document.body.style.setProperty('--el-color-black', 'hsl(var(--primary-foreground))')
  watch(() => settingsStore.currentColorScheme, (val) => {
    if (val === 'light') {
      for (let index = 1; index < 10; index++) {
        document.body.style.setProperty(`--el-color-primary-light-${index}`, `color-mix(in hsl, hsl(var(--primary)), #fff ${index * 10}%)`)
        document.body.style.setProperty(`--el-color-primary-dark-${index}`, `color-mix(in hsl, hsl(var(--primary)), #000 ${index * 10}%)`)
        document.body.style.setProperty(`--weyon-primary-color-light-${index}`, `color-mix(in hsl, hsl(var(--primary)), #fff ${index * 10}%)`)
        document.body.style.setProperty(`--weyon-primary-color-dark-${index}`, `color-mix(in hsl, hsl(var(--primary)), #000 ${index * 10}%)`)
      }
    }
    else {
      for (let index = 1; index < 10; index++) {
        document.body.style.setProperty(`--el-color-primary-light-${index}`, `color-mix(in hsl, hsl(var(--primary)), #000 ${index * 10}%)`)
        document.body.style.setProperty(`--el-color-primary-dark-${index}`, `color-mix(in hsl, hsl(var(--primary)), #fff ${index * 10}%)`)
        document.body.style.setProperty(`--weyon-primary-color-light-${index}`, `color-mix(in hsl, hsl(var(--primary)), #000 ${index * 10}%)`)
        document.body.style.setProperty(`--weyon-primary-color-dark-${index}`, `color-mix(in hsl, hsl(var(--primary)), #fff ${index * 10}%)`)
      }
    }
  }, {
    immediate: true,
  })
}
else {
  document.body.style.setProperty('--el-bg-color', 'hsl(var(--background))')
  document.body.style.setProperty('--el-color-primary', 'hsl(var(--primary))')
  document.body.style.setProperty('--weyon-primary-color', 'hsl(var(--primary))')
  document.body.style.setProperty('--el-color-white', 'hsl(var(--primary-foreground))')
  document.body.style.setProperty('--el-color-black', 'hsl(var(--primary-foreground))')

  function parseHsl(str: string) {
    const m = str.trim().match(/^(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)%\s+(\d+(?:\.\d+)?)%$/)
    if (!m) {
      return null
    }
    return { h: Number(m[1]), s: Number(m[2]), l: Number(m[3]) }
  }
  function toHsl(v: { h: number, s: number, l: number }) {
    const h = Math.max(0, Math.min(360, v.h))
    const s = Math.max(0, Math.min(100, v.s))
    const l = Math.max(0, Math.min(100, v.l))
    return `${h} ${s}% ${l}%`
  }
  function adjustLightness(src: string, factor: number, mode: 'lighten' | 'darken') {
    const p = parseHsl(src)
    if (!p) {
      return src
    }
    const t = Math.max(0, Math.min(1, factor))
    const l = mode === 'lighten' ? p.l + (100 - p.l) * t : p.l * (1 - t)
    return toHsl({ h: p.h, s: p.s, l })
  }
  function getPrimary() {
    const v = getComputedStyle(document.documentElement).getPropertyValue('--primary').trim()
    return v || '0 0% 0%'
  }

  watch(() => settingsStore.currentColorScheme, (val) => {
    const base = getPrimary()
    if (val === 'light') {
      for (let index = 1; index < 10; index++) {
        const t = index / 10
        const darkHsl = adjustLightness(base, t, 'darken')
        const lightHsl = adjustLightness(base, t, 'lighten')
        document.body.style.setProperty(`--el-color-primary-dark-${index}`, `hsl(${darkHsl})`)
        document.body.style.setProperty(`--el-color-primary-light-${index}`, `hsl(${lightHsl})`)
        document.body.style.setProperty(`--weyon-primary-color-light-${index}`, `hsl(${lightHsl})`)
        document.body.style.setProperty(`--weyon-primary-color-dark-${index}`, `hsl(${darkHsl})`)
      }
    }
    else {
      for (let index = 1; index < 10; index++) {
        const t = index / 10
        const darkHsl = adjustLightness(base, t, 'lighten')
        const lightHsl = adjustLightness(base, t, 'darken')
        document.body.style.setProperty(`--el-color-primary-dark-${index}`, `hsl(${darkHsl})`)
        document.body.style.setProperty(`--el-color-primary-light-${index}`, `hsl(${lightHsl})`)
        document.body.style.setProperty(`--weyon-primary-color-light-${index}`, `hsl(${lightHsl})`)
        document.body.style.setProperty(`--weyon-primary-color-dark-${index}`, `hsl(${darkHsl})`)
      }
    }
  }, { immediate: true })
}
</script>

<template>
  <ElConfigProvider :locale="zhCN" :button="{ autoInsertSpace: true }">
    <slot />
  </ElConfigProvider>
</template>
